import { Component, OnInit } from '@angular/core';
import { StudentModel } from '../../../models/authentication/student.model';
import { SchoolModel } from '../../../models/school/school.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminStudentService } from '../../../services/admin/admin-student.service';
import { AdminSchoolService } from '../../../services/admin/admin-school.service';
import { AdminPasswordValidationService } from '../../admin-users/admin-passord-validation/admin-password-validation.service';


@Component({
  selector: 'app-school-student-edit',
  templateUrl: './admin-student-edit.component.html',
  styleUrls: ['./admin-student-edit.component.css']
})
export class AdminStudentEditComponent implements OnInit {


  student: StudentModel = new StudentModel();
  oldStudent: StudentModel = new StudentModel();
  school: SchoolModel = new SchoolModel();
  SchoolTypes = StudentModel.SchoolTypesDropdownList;
  ListBillingStatus = StudentModel.ChargebeeSubscriptionsStatusTypesDropdownList;

  constructor(private adminStudentSv: AdminStudentService, private adminSchoolSv: AdminSchoolService, public adminPasswordValidationSv: AdminPasswordValidationService, private route: ActivatedRoute) { }

  ngOnInit() {
    const id: string = String(this.route.snapshot.paramMap.get('studentId'));
    this.adminStudentSv.fetchStudentById(id).subscribe((student) => {
      this.oldStudent = student;
      this.student = StudentModel.generateModel(JSON.parse(JSON.stringify(student)));

      if (this.student.schoolId) {
        this.adminSchoolSv.fetchSchoolById(this.student.schoolId).subscribe((school) => {
          this.school = school;
        });
      }
    });
  }
  onSaveClicked() {
    this.adminPasswordValidationSv.show().subscribe((adminPassword) => {
      if (adminPassword !== null && adminPassword !== undefined) {

        this.adminStudentSv.updateStudentWithAdminPassword(this.student, adminPassword).subscribe(updatedStudent => {
          this.student = StudentModel.generateModel(JSON.parse(JSON.stringify(updatedStudent)));
          this.oldStudent = StudentModel.generateModel(JSON.parse(JSON.stringify(updatedStudent)));
        });
      }
    });
  }

  onCancelClick() {
    this.student = StudentModel.generateModel(JSON.parse(JSON.stringify(this.oldStudent)));
  }

}
